var map = {
	"./de/languages": [
		"NTBw",
		55
	],
	"./en/languages": [
		"Mktx",
		39
	],
	"./fr/languages": [
		"4wLJ",
		23
	],
	"./nl/languages": [
		"L0ba",
		7
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "5HJR";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./resources/js/lang lazy ^\.\/.*\/languages$
// module id = 5HJR
// module chunks = 97